import { Navigate } from 'react-router';

import { paths } from '@/app/routes/paths';
import { resolveDefaultHomePath } from '@/features/auth/lib/default-home-path';
import { useAuthStore } from '@/store';

export function RootRedirect() {
  const user = useAuthStore((s) => s.user);
  if (user) {
    return <Navigate to={resolveDefaultHomePath(user)} replace />;
  }
  return <Navigate to={paths.login} replace />;
}
